export interface DiscountInfo {
  discount_percentage?: number | null;
  discount_start_date?: string | null;
  discount_end_date?: string | null;
  discounted_price_cents?: number | null;
}

export function isDiscountActive(discountInfo: DiscountInfo): boolean {
  if (!discountInfo.discount_percentage || discountInfo.discount_percentage === 0) {
    return false;
  }

  const now = new Date();
  const startDate = discountInfo.discount_start_date ? new Date(discountInfo.discount_start_date) : null;
  const endDate = discountInfo.discount_end_date ? new Date(discountInfo.discount_end_date) : null;

  if (startDate && now < startDate) {
    return false;
  }

  if (endDate && now > endDate) {
    return false;
  }

  return true;
}

export function getEffectivePrice(
  originalPriceCents: number,
  discountInfo: DiscountInfo
): number {
  if (isDiscountActive(discountInfo) && discountInfo.discounted_price_cents) {
    return discountInfo.discounted_price_cents;
  }
  return originalPriceCents;
}

export function formatPrice(cents: number, currency: string = "EUR"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(cents / 100);
}